import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { deleteSubscription } from "@/common/services/subscription.api";
import { Modal } from "flowbite-react";
import FormDeleteSubscription from "../forms/FormDeleteSubscription";

type PropsDeleteSubscription = {
  subscriptionId: string;
  renterId?: string;
  onClose: () => void;
}

export function ModalDeleteSubscription(props: PropsDeleteSubscription) {
  const { notifySuccess, notifyError } = useToastContext();
  const handleCloseModal = () => { props.onClose(); };

  async function deleteSubscriptions(data) {
    const result = await deleteSubscription(props.subscriptionId, data);
    if (result && result.ok) {
      notifySuccess("Assinatura excluída com sucesso");
      handleCloseModal();
    } else {
      notifyError("Erro ao excluir assinatura");
    }
  }
  return (
    <Modal
      className="relative dark:text-black"
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header>Excluir Assinatura</Modal.Header>
      <Modal.Body>
        {props.subscriptionId && props.renterId && (
          <FormDeleteSubscription
            subscriptionId={props.subscriptionId}
            onClose={handleCloseModal}
            renterId={props.renterId}
            onSave={(subscriptionId) => subscriptionId}
            onSubmit={deleteSubscriptions}
            reason="Motivo da exclusão"
          />
        )}
      </Modal.Body>

    </Modal>
  )
}